import React from "react";
import { IonHeader, IonToolbar } from "@ionic/react";
import KnownWords from "./KnownWords";
import Droplets from "./Droplets";
import logo from "../../assets/ParrotLogo.svg";
import { haptic } from "@/lib/haptic";
import { useNavigate } from "react-router-dom";
import { ActivePage } from "../NavBar/NavBar";

interface HeaderProps {
  activePage: ActivePage;
}

const Header: React.FC<HeaderProps> = ({ activePage }) => {
  const nav = useNavigate();
  const renderHeaderContent = () => {
    switch (activePage) {
      case "learn":
        return <div className="py-2 font-medium">Home</div>;
      case "dictionary":
        return <div className="py-2 font-medium">Review</div>;
      case "profile":
        return <div className="py-2 font-medium">Profile</div>;
      case "grow":
        return <div className="py-2 font-medium">Grow</div>;
      case "courses":
        return <div className="py-2 font-medium">Courses</div>;
      default:
        return null;
    }
  };

  return (
    <IonHeader translucent={false} className="w-full h-full bg-inherit">
      <IonToolbar>
        <div className="w-full h-full flex flex-row items-center justify-end gap-1 p-3 pr-2 bg-[#fafafa] relative">
          <img
            src={logo}
            alt="Parrot"
            onClick={() => {
              haptic.soft();
              nav("/home/learn");
            }}
            className="absolute left-4 top-[10px] w-9 h-9"
          />
          <div className="absolute left-1/2 transform -translate-x-1/2 z-10">
            {renderHeaderContent()}
          </div>
          <KnownWords />
          <Droplets pulse={false} />
        </div>
      </IonToolbar>
    </IonHeader>
  );
};

export default Header;
